
export enum WebToastDataResponseLevel {
    "SUCCESS" = "SUCCESS",
    "INFO" = "INFO",
    "WARNING" = "WARNING",
    "ERROR" = "ERROR",
    "NEUTRAL" = "NEUTRAL"
}
export type WebToastDataResponse = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    title: string;
    /**
     * @type string
    */
    body: string;
    /**
     * @type string
    */
    level: WebToastDataResponseLevel;
    /**
     * @type string date-time
    */
    createDate: string;
};
